module.exports = __webpack_public_path__ + "media/images/hero/hero1-house-wall-left-b4ceb63dd98e35ffaff40685f1ca3333.svg";